import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

import styles from './Dashboard.module.scss';

interface Props {
  dataSource: {
    title: string;
    time?: string;
    location?: string;
    productHierarchy?: string;
    totalSeasons?: number;
    activePreSeasons?: number;
    targetPreSeasons?: number;
    quarters?: string;
    path: string;
  };
}

interface State {
}

export default class DashboardCard extends React.PureComponent<Props, State> {
  constructor(props) {
    super(props);
  }

  render(): React.ReactNode {
    return (
      <Link to={`/${this.props.dataSource.path}`}>
        <div className={styles['card-container']}>
          <div className={styles['header-container']}>
            <p className={styles['card-title']}>{this.props.dataSource.title}</p>
          </div>

          {
            ['Season Configuration', 'Planning Window Configuration', 'Run Rate Plan'].indexOf(this.props.dataSource.title) === -1 &&
            <React.Fragment>
              <p className={styles['card-label']}>Time</p>
              <p className={styles['card-value']}>{this.props.dataSource.time}</p>

              <Row style={{ marginTop: '24px' }}>
                <Col md={6}>
                  <p className={styles['card-label']}>Location/store</p>
                  <p className={styles['card-value']}>{this.props.dataSource.location}</p>
                </Col>

                <Col md={6}>
                  <p className={styles['card-label']}>Product Hierarchy</p>
                  <p className={styles['card-value']}>{this.props.dataSource.productHierarchy}</p>
                </Col>
              </Row>
            </React.Fragment>
          }

          {
            ['Season Configuration'].indexOf(this.props.dataSource.title) !== -1 &&
            <React.Fragment>
              <p className={styles['card-label']}>
                {this.props.dataSource.title === 'Total seasons'}
              </p>
              <p className={styles['card-value']}>
                {this.props.dataSource['totalSeasons']}
              </p>

              <Row style={{ marginTop: '24px' }}>
                <Col md={6}>
                  <p className={styles['card-label']}>Active pre-seasons</p>
                  <p className={`${styles['card-value']} text-success`}>
                    {this.props.dataSource.activePreSeasons}
                  </p>
                </Col>

                <Col md={6}>
                  <p className={styles['card-label']}>Target pre-seasons</p>
                  <p className={styles['card-value']}>{this.props.dataSource.targetPreSeasons}</p>
                </Col>
              </Row>
            </React.Fragment>
          }

          {
            ['Planning Window Configuration', 'Run Rate Plan'].indexOf(this.props.dataSource.title) !== -1 &&
            <React.Fragment>
              <Row style={{ marginTop: '24px' }}>
                <p></p><p></p>
                <Col md={6}>
                  <p className={styles['card-label']}>Location/store</p>
                  <p className={styles['card-value']}>{this.props.dataSource.location}</p>
                </Col>

                <Col md={6}>
                  <p className={styles['card-label']}>Product Hierarchy</p>
                  <p className={styles['card-value']}>{this.props.dataSource.productHierarchy}</p>
                </Col>
              </Row>
            </React.Fragment>
          }

        </div>
      </Link>
    );
  }
}
